import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Mujeres de 45 a 65 años que sienten su metabolismo "estancado".', 'Aquellas que sufren de inflamación abdominal constante.', 'Mujeres que quieren energía estable durante todo el día sin depender del café.', 'Quienes buscan un método sostenible, basado en ciencia y sin suplementos caros.'];
  const isNotFor = ['Personas que buscan una "pastilla mágica" sin cambiar ningún hábito.', 'Quienes no estén dispuestas a dejar de lado los productos ultraprocesados por 21 días.', 'Hombres o mujeres jóvenes (este manual es específico para el perfil hormonal 45+).'];
  return <section className="py-20 bg-white" data-id="element-227">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-228">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-229">
          {/* Who this is for */}
          <FadeIn direction="right" data-id="element-230">
            <div className="bg-brand-light rounded-3xl p-8 md:p-10 h-full border-t-8 border-brand-green" data-id="element-231">
              <h3 className="font-serif text-2xl md:text-3xl font-bold text-brand-charcoal mb-8 flex items-center gap-3" data-id="element-232">
                <span className="bg-brand-green text-white w-8 h-8 rounded-full flex items-center justify-center text-lg" data-id="element-233">
                  ✓
                </span>
                Este programa ES para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-234">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-235">
                    <CheckCircle2 className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-236" />
                    <span className="text-gray-700 font-medium leading-relaxed" data-id="element-237">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who this is not for */}
          <FadeIn direction="left" delay={0.2} data-id="element-238">
            <div className="bg-gray-50 rounded-3xl p-8 md:p-10 h-full border-t-8 border-gray-300" data-id="element-239">
              <h3 className="font-serif text-2xl md:text-3xl font-bold text-brand-charcoal mb-8 flex items-center gap-3" data-id="element-240">
                <span className="bg-gray-400 text-white w-8 h-8 rounded-full flex items-center justify-center text-lg" data-id="element-241">
                  ✕
                </span>
                Este programa NO es para:
              </h3>
              <ul className="space-y-6" data-id="element-242">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-243">
                    <XCircle className="w-6 h-6 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-244" />
                    <span className="text-gray-600 leading-relaxed" data-id="element-245">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}